import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VListItem,{attrs:{"disabled":_vm.getProdutosSelecionadosCarrinho == 0},on:{"click":function($event){$event.preventDefault();return _vm.abrirDialogCotacaoPedido()}}},[_c(VIcon,{attrs:{"size":"19"}},[_vm._v("mdi-format-list-checks")]),_c('p',{staticClass:"ma-0 ml-2"},[_vm._v("Abrir cotação")]),_c('Cotacao',{attrs:{"pedido":_vm.pedido,"ativacao_dialog_personalizada":"abrir"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }